'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./PasswordValidationTicks.scss');

var PasswordValidationTicks = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PasswordValidationTicks, _Component);

  function PasswordValidationTicks() {
    (0, _classCallCheck3.default)(this, PasswordValidationTicks);
    return (0, _possibleConstructorReturn3.default)(this, (PasswordValidationTicks.__proto__ || (0, _getPrototypeOf2.default)(PasswordValidationTicks)).apply(this, arguments));
  }

  (0, _createClass3.default)(PasswordValidationTicks, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          value = _props.value,
          _props$errors = _props.errors,
          errors = _props$errors === undefined ? {} : _props$errors;

      var getClass = function getClass(isError) {
        return (0, _classnames2.default)(isError || !value ? styles.error : styles.success);
      };

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-60 col-sm-30' },
          _react2.default.createElement(
            'div',
            { className: getClass(errors.lowercase) },
            _react2.default.createElement('i', null),
            _react2.default.createElement(
              'span',
              null,
              t('One lowercase character')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: getClass(errors.uppercase) },
            _react2.default.createElement('i', null),
            _react2.default.createElement(
              'span',
              null,
              t('One uppercase character')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: getClass(errors.number) },
            _react2.default.createElement('i', null),
            _react2.default.createElement(
              'span',
              null,
              t('One number')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-60 col-sm-30' },
          _react2.default.createElement(
            'div',
            { className: getClass(errors.symbol) },
            _react2.default.createElement('i', null),
            _react2.default.createElement(
              'span',
              null,
              t('One special symbol')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: getClass(errors.length) },
            _react2.default.createElement('i', null),
            _react2.default.createElement(
              'span',
              null,
              t('8 characters minimum')
            )
          )
        )
      );
    }
  }]);
  return PasswordValidationTicks;
}(_react.Component), _class2.propTypes = {
  errors: _propTypes2.default.object,
  t: _propTypes2.default.func,
  value: _propTypes2.default.string
}, _temp)) || _class);
exports.default = PasswordValidationTicks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PasswordValidationTicks/PasswordValidationTicks.js
// module id = 2037
// module chunks = 1